import { AfterViewInit, ChangeDetectorRef, Component, DebugElement, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { BlendProperties, ErrCode, LinkApiOutput, LinkItem, LinkListItem, LinkNewApiOutput, User } from 'src/app/shared/models';
import { IFile } from 'src/sync';
import * as FileListActions from 'src/app/actions/file-list.actions';
import { JoblockService } from 'src/app/core/joblock.service';
import { ApiService } from 'src/app/core/api.service';
import { Base64Service } from 'src/app/core/base64.service';
import { DirtyOutService } from 'src/app/core/crypt/dirty-out.service';
import { LinkPasswordService } from 'src/app/links/services/link-password.service';
import { LoggerService } from 'src/app/core/logger.service';
import { UserService } from 'src/app/core/user.service';
import { Store } from '@ngrx/store';
import { State } from 'src/app/reducers';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { LinkListService } from 'src/app/links/services/link-list.service';
import { CensorSensor } from 'censor-sensor';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { mapFormToApiParams } from '../link-permissions-form/link-permissions-form.component';
import { FileItemService } from 'src/app/file/file-item.service';
import { FeatureService } from 'src/app/shared/services/feature.service';
import { NotificationsService } from 'src/app/core/notifications.service';
import { ProgressPayload } from 'src/app/shared/models/websocket/action-payload';
import { WebSocketService } from 'src/app/core/websocket.service';
import { Subscription } from 'rxjs';
import { MessageType } from 'src/app/shared/models/websocket/websocket-message';
const censor = new CensorSensor();

interface Fields {
  permissionsForm: FormControl<any>;
}

@Component({
  selector: 'app-link-create',
  templateUrl: './link-create.component.html',
  styleUrls: ['./link-create.component.scss']
})
export class LinkCreateComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() openState: number;
  @Input() item: LinkListItem | IFile;
  @Input() showCreateLinkDialog: boolean;
  @Input() isCreateLink: boolean;
  @Input() fileType: string;
  @Input() fileName: string;
  @Input() onLinkMutate?: Function;

  @Output() state = new EventEmitter<number>();
  @Output() showCreateLinkDialogChange = new EventEmitter<boolean>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<boolean>();


  public total = 0;
  public finished = 0;
  public errcode: ErrCode;
  public verified: boolean;
  public isLinkLimit: boolean;
  public spinner: boolean;
  public linkLimitAmt = 0;

  public newlinkjob: LinkApiOutput;
  public newLink: LinkNewApiOutput;
  public bg = 1;
  public cachekey: string;
  public modalText: string;
  public dialogTitle:string = 'Create link';
  public user: User;
  public isLoading: boolean = false;
  public linkCreated: boolean = false;
  protected linkForm: FormGroup<Fields>;
  protected link;
  public isVerified: boolean;
  public isComponentInitialized: boolean = false;
  private progressSubscription: Subscription;

  constructor(
    private api: ApiService,
    private joblockService: JoblockService,
    private base64: Base64Service,
    private dirtyOut: DirtyOutService,
    private linkPassword: LinkPasswordService,
    private log: LoggerService,
    private store: Store<State>,
    private userService: UserService,
    private snackbarService: SnackbarService,
    private cdr: ChangeDetectorRef,
    private linkList: LinkListService,
    private fb: FormBuilder,
    private fileItemService: FileItemService,
    private notificationsService: NotificationsService,
    private webSocketService: WebSocketService,
  ) {}

  async ngOnInit() {
    this.isComponentInitialized = false;
    const isMSOfficeFile = this.fileItemService.isMSOffice(this.item as IFile, 'edit');
    this.isVerified = this.userService.get('is_verified');
    let defaultPermission: BlendProperties = BlendProperties.LINK_PERMISSION_DOWNLOAD;
    if (this.fileType === 'dir') {
      defaultPermission = BlendProperties.LINK_PERMISSION_DOWNLOAD_FOLDER_CONTENTS;
    }
    else if (isMSOfficeFile) {
      if (this.item.is_shared) {
        defaultPermission = BlendProperties.LINK_PERMISSION_DOWNLOAD;
      }
    }

    this.link = {
      type: this.fileType,
      ...mapFormToApiParams(defaultPermission, false, this.fileType)
    }

    this.linkForm = this.fb.group({
      permissionsForm: [''],
    });

    if (this.item.is_publink) {
      this.state.emit(1);
      return;
    }

    this.user = this.userService.getUser();

    if (this.item.is_publink) {
      this.state.emit(1);
      return;
    }

    this.showCreateLinkDialog = true;
    this.isComponentInitialized = true;

  }

  ngOnDestroy() {
    this.progressSubscription?.unsubscribe?.();
  }

  ngAfterViewInit() {
    if (this.openState === 5) {
      this.createLink();
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  handleCloseConfirmation($event) {
    if (this.isLoading) {
      $event.returnValue = 'Are you sure you want to close this? This will continue to process in the background';
    }
  }  

  public async postLinkCreateAction() {
    this.notificationsService.stopNotificationLoop();
    this.modalText = 'Encrypting link, Please wait...';

    const updateModalText = (progress: number) => {
      this.modalText = `Encrypting link ${progress}%, Please wait...`
    };

    this.cachekey =
      this.bg == 1 ? this.newlinkjob.cachekey : this.newLink.cachekey;
    this.log.info(
      'cachekey filter  status : ' + censor.isProfaneIsh(this.cachekey)
    );

    this.total = this.bg == 1 ? this.newlinkjob.cnt : this.newLink.cnt;
    this.finished = 0;
    while (this.finished < this.total) {
      const data = await this.dirtyOut.executeForShare(
        this.bg == 1 ? this.newlinkjob.share_id : this.newLink.share_id
      );
      if (!data || (Array.isArray(data) && data.length === 0)) {
        this.finished = this.total;
        updateModalText(100);
      }
      if (data && data.completed) {
        this.finished += data.completed;
        const percentage = Math.min(Math.round((this.finished / this.total) * 100), 100);
        updateModalText(percentage);

        if (this.finished >= this.total) {
          updateModalText(100);
          break;
        }
      }
    }

    if (this.onLinkMutate) {
      this.onLinkMutate();
    }
    else {
      this.store.dispatch(new FileListActions.FileListReloadAction());
    }

    if (this.showCreateLinkDialog) {
      this.state.emit(1);
    }
    this.notificationsService.startNotificationLoop();
    this.log.info('post link action completed');
  }

  onBack = () => {
    this.closeCreateLinkDialog();
  }

  closeCreateLinkDialog = () => {
    if (this.showCreateLinkDialog && this.isLoading) {
      if (!window.confirm('Are you sure you want to close this? This will continue to process in the background')) {
        return;
      }
      this.snackbarService.showMessage('default', 'The action will continue processing until finished.');
    }
    this.showCreateLinkDialog = false;
    setTimeout(() => { 
      this.showCreateLinkDialogChange.next(false);
      this.close.emit(false);
    });
  }

  getLinkPassword = () => {
    let pass = this.linkPassword.makeLinkPassword(32);
    while (censor.isProfaneIsh(pass)) {
      pass = this.linkPassword.makeLinkPassword(32);
    }
    return this.linkPassword.makePasswordData(pass);
  }

  createLink = async () => {
    if (this.linkForm.valid) {
      this.dialogTitle = 'Share link';
      this.isLoading = true;

      this.modalText = 'Creating link...';
      try {
        let expServtime;
        if (this.linkForm.controls.permissionsForm.value.use_link_expiry) {
          const expDate = this.linkForm.controls.permissionsForm.value.exp_date
          const [hours, minutes] = this.linkForm.controls.permissionsForm.value.exp_time.split(':');
          const dt = new Date(
            expDate.getFullYear(),
            expDate.getMonth(),
            expDate.getDate(),
            parseInt(hours, 10),
            parseInt(minutes, 10),
            0
          );
          expServtime = dt.getTime();
        }

        this.progressSubscription = this.webSocketService
          .getMessageHandler<ProgressPayload>(MessageType.LINK_NEW_PROGRESS)
          .subscribe((progress) => {
            if (progress.sync_id === this.item.sync_id) {  
              this.modalText = `Creating link ${progress.progressPercentage}%, Please wait...`;
            }
          });

        const passdata = await this.getLinkPassword();

        const password = this.linkForm.controls.permissionsForm.value.use_password && this.base64.encode(
          this.linkForm.controls.permissionsForm.value.passwordprotect
        );

        const linkParams = {
          sync_id: this.item.sync_id,
          label: this.base64.encode(this.item.name),
          enc_share_key: passdata.enc_share_key,
          enc_password: passdata.enc_password,
          salt: passdata.salt,
          iterations: passdata.iterations,
          bg: this.bg,
          exp_servtime: expServtime,
          ...mapFormToApiParams(this.linkForm.controls.permissionsForm.value.permission, this.linkForm.controls.permissionsForm.value.upload, this.link.type),
          ...(password ? { password } : {}),
        };
  
        do {
          this.newLink = await this.api.execute<LinkNewApiOutput>('linknew', linkParams);
          this.bg = this.newLink.bg;
          this.dialogTitle = 'Share link';
          this.modalText = this.bg === 1
            ? `Creating link 0%, Please wait...`
            : 'Creating link, Please wait...';
          if (this.bg == 1) {
            await this.joblockService.pollJobStatus();
            this.newlinkjob = await this.api.execute<LinkApiOutput>(
              'linkget',
              {
                sync_id: this.item.sync_id,
              }
            );
          }
  
        } while (censor.isProfaneIsh(this.bg == 1 ? this.newlinkjob.cachekey : this.newLink.cachekey));
          
        this.linkCreated = true;
        await this.postLinkCreateAction();
        this.showCreateLinkDialog = false;
      } catch (error) {
        this.errcode = ErrCode.fromException(error);
        if (!this.errcode.msg || this.errcode.msg === 'An unknown error occurred') {
          this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
        }
        if (error instanceof ErrCode) {
          if (error.code == 8028) {
            this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
            if (error.msg) {
              console.warn('Link limit is reached ' + error.msg);
              const limit = error.msg.toString().match(/\(([0-9]+)\)/);
              this.log.info(limit);
              if (limit !== null && parseInt(limit[1], 10) > 0) {
                this.linkLimitAmt = parseInt(limit[1], 10);
              } else {
                console.error(
                  'Could not determine the link limit from the API, hardcoding to a limit of 3.  Received : "' +
                  error.msg +
                  '"'
                );
                this.linkLimitAmt = 3;
              }
            }
            this.isLinkLimit = true;
          } else {
            this.errcode = error;
          }
        }
      } finally {
        this.linkCreated = true;
        this.isLoading = false;
        this.isCreateLink = false;
        this.modalText = '';
      }
    }
  }

  ngOnChanges() {
    this.cdr.detectChanges();
  }

  get isActionButtonDisabled() {
    return this.linkForm?.invalid;
  }
}
